import {
    AutoAwesomeOutlined,
    BadgeOutlined,
    // BlockOutlined,
    // CheckCircleOutlineOutlined,
    FavoriteBorderOutlined,
    SchoolOutlined
} from '@mui/icons-material';
import DocPageLayout from './DocPageLayout.js';
import './DocPage.css';

const heroImage = '/img/counseling-session.jpg';
const secondaryImage = '/img/hero-clinic.jpg';
const profileImage = '/concept/profile.webp';

// const notIdealItems = [
//     '1回ですべてを治したいとお考えの方',
//     'ご自身では改善に取り組む意志がない方',
//     '施術者の話やアドバイスを素直に聞けない方',
//     '健康のための投資ができない方',
//     '原因を他人や環境のせいにして向き合う気がない方'
// ];

// const idealItems = [
//     '生活の質を高めたい方',
//     '慢性的な痛みや不調を終わりにしたい方',
//     '自己治癒力を高めて健康レベルを上げたい方',
//     '生活習慣を見直して身体を大切にしたい方',
//     '原因を突き止め、自分に合った施術を受けたい方'
// ];

const profileItems = [
    {
        title: '経歴',
        description: '施術歴15年',
        Icon: BadgeOutlined
    },
    {
        title: '資格',
        description:
            '鍼灸師 / 登録販売者（医薬品） / 国際中医師専門員（漢方） / タッチフォーヘルス（レベル4） / 小波津式神経無痛療法（アドバンス） / 良導絡測定アドバイザー など',
        Icon: SchoolOutlined
    },
    {
        title: '学び',
        description: '現在も勉強会・セミナーに参加して学び続けています。',
        Icon: AutoAwesomeOutlined
    }
];


const profileGalleryImages = [
    {
        src: '/concept/image1-1024x768.webp',
        alt: '施術前のカウンセリング風景'
    },
    {
        src: '/concept/image0-1024x768.webp',
        alt: '院内の落ち着いた空間'
    },
    {
        src: '/concept/IMG_20220803_0001-725x1024.webp',
        alt: '院長の資格証（1）'
    },
    {
        src: '/concept/IMG_20220803_0002-743x1024.webp',
        alt: '院長の資格証（2）'
    },
    {
        src: '/concept/IMG_20220912_0001-720x1024.webp',
        alt: '院長の資格証（3）'
    },
    {
        src: '/concept/SKM_C75923103113220-scaled-e1698731551959-724x1024.webp',
        alt: '院長の資格証（4）'
    }
];

const Concept = () => (
    <DocPageLayout
        currentRoute="/concept"
        pageLabel="CONCEPT"
        pageTitle="本来の力を最大限に引き出し、輝く人生を"
        heroImage={heroImage}
        heroImageAlt="カウンセリングの様子"
        heroHighlight="楽しく、健康で、美しく過ごせる日々をご提供"
        heroDescription="心と身体のつながりを大切に、やさしく寄り添う治療院であり続けます。"
    >
        <article className="doc-section">
            <h3 className="doc-section__title">当院のコンセプト</h3>
            <div className="doc-section__body">
                <p>
                    当院では「本来の力を最大限に引き出し、輝く人生を生きる」をテーマに、慢性的な痛みや不調にお悩みの方が楽しく、健康で、美しく過ごせる日々をサポートします。
                </p>
                <p>
                    東洋医学と西洋医学の両面から全身を見つめ、お一人おひとりに合わせたオーダーメイド施術を行います。「心身同源」の考えを大切に、心の状態と身体の状態のバランスを丁寧に整えていきます。
                </p>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">ごあいさつ</h3>
            <div className="doc-section__body">
                <p>
                    はじめまして。院長の田中です。数ある院の中から当院のページをご覧いただきありがとうございます。施術の前には、生活習慣や心と身体の関連性、根本原因をカウンセリングで丁寧に把握し、最適な施術プランをご提案いたします。
                </p>
                <p>
                    痛みや症状のある部位だけにとらわれず、全身のバランスを確認しながら根本改善を追求します。つらい症状を抱えている方は、一人で悩まずにお気軽にご相談ください。
                </p>
                <div className="doc-section__media">
                    <img src={secondaryImage} alt="院内の雰囲気" loading="lazy" />
                </div>
            </div>
        </article>

        {/* <article className="doc-section">
            <h3 className="doc-section__title">
                <BlockOutlined className="doc-section__icon" />当院に向いていない方
            </h3>
            <ul className="doc-list">
                {notIdealItems.map((item) => (
                    <li key={item}>
                        <BlockOutlined className="doc-list__icon" />
                        <span className="doc-list__content">{item}</span>
                    </li>
                ))}
            </ul>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <CheckCircleOutlineOutlined className="doc-section__icon" />当院に向いている方
            </h3>
            <ul className="doc-list">
                {idealItems.map((item) => (
                    <li key={item}>
                        <CheckCircleOutlineOutlined className="doc-list__icon" />
                        <span className="doc-list__content">{item}</span>
                    </li>
                ))}
            </ul>
        </article> */}

        <article className="doc-section">
            <h3 className="doc-section__title">
                <FavoriteBorderOutlined className="doc-section__icon" />最後に
            </h3>
            <p className="doc-highlight">
                辛い症状を本気で改善したいとお考えの方は、ぜひ当院までご相談ください。楽しく、健康で、美しく過ごせる日々を取り戻せるよう全力でサポートいたします。
            </p>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <BadgeOutlined className="doc-section__icon" />院長プロフィール詳細
            </h3>
            <div className="doc-profile">
                <div className="doc-profile__image">
                    <img src={profileImage} alt="院長のプロフィール写真" loading="lazy" />
                </div>
                <div className="doc-profile__identity">
                    <p className="doc-profile__clinic">Takajyu鍼灸・整体院</p>
                    <p className="doc-profile__name">田中 隆明</p>
                </div>
            </div>
            <div className="doc-section__body">
                <div className="doc-list">
                    {profileItems.map(({ title, description, Icon }) => (
                        <li key={title}>
                            <Icon className="doc-list__icon" />
                            <span className="doc-list__content">
                                <strong>{title}</strong>
                                {description}
                            </span>
                        </li>
                    ))}
                </div>
            </div>

            <div className="doc-gallery">
                {profileGalleryImages.map(({ src, alt }) => (
                    <div className="doc-gallery__item" key={src}>
                        <img src={src} alt={alt} loading="lazy" />
                    </div>
                ))}
            </div>
        </article>
    </DocPageLayout>
);

export default Concept;
